// extracted by mini-css-extract-plugin
export default {"review":"ReviewProduct_review__bonbc","card":"ReviewProduct_card__tpDZN"};